/* eslint-disable prettier/prettier */
import Vue from '@/node_modules/vue'
// import VueGraph from 'vue-graph'

// Vue.use(VueGraph)
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)
